export default __webpack_public_path__ + "97f7bc5993e16d40270eb152253aa3cb.png";